/**
 * Markdown工具函数
 * 处理Markdown相关的转换和格式化
 */

/**
 * 将Markdown内容转换为二进制数据
 * @param {string} content - Markdown内容
 * @param {string} filename - 文件名（可选）
 * @returns {Blob} - 二进制数据
 */
export const markdownToBlob = (content, filename = 'document.md') => {
  // 创建包含Markdown内容的Blob对象
  const blob = new Blob([content], { 
    type: 'text/markdown;charset=utf-8' 
  });
  
  return blob;
};

/**
 * 将Markdown内容转换为File对象
 * @param {string} content - Markdown内容
 * @param {string} filename - 文件名
 * @returns {File} - File对象
 */
export const markdownToFile = (content, filename = 'document.md') => {
  const blob = markdownToBlob(content, filename);
  return new File([blob], filename, { 
    type: 'text/markdown;charset=utf-8' 
  });
};

/**
 * 从二进制数据读取Markdown内容
 * @param {Blob|File} blob - 二进制数据
 * @returns {Promise<string>} - Markdown内容
 */
export const blobToMarkdown = async (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsText(blob, 'utf-8');
  });
};

/**
 * 生成文档文件名
 * @param {string} title - 文档标题
 * @param {string} extension - 文件扩展名（默认为.md）
 * @returns {string} - 文件名
 */
export const generateDocumentFilename = (title, extension = '.md') => {
  // 清理标题，移除特殊字符，只保留字母、数字、中文和空格
  const cleanTitle = title.replace(/[^\w\s\u4e00-\u9fff]/g, '').trim();
  // 将空格替换为下划线
  const filename = cleanTitle.replace(/\s+/g, '_');
  // 添加时间戳避免重名
  const timestamp = new Date().toISOString().slice(0, 19).replace(/[-:]/g, '');
  return `${filename}_${timestamp}${extension}`;
};
